<template>
  <div id="pdf_area">
    <template v-if="showQr">
      <div class="message_area">
        <h3>控え書面のご確認</h3>
        担当者に、こちらのタブレットをお渡しください。
        <el-divider></el-divider>
        <div id="el-oneTime" class="el-oneTime">
          <el-row type="flex" align="middle" :gutter="20">
            <el-col :span="12">
              <p class="el-oneTime__text">
                受付番号: {{ getHasContractId }}<br />{{
                  `${getUserInputForm.surname} ${getUserInputForm.first_name}`
                }}様専用
              </p>
              <div v-if="oneTimeLoginUrl !== ''" class="el-oneTime__qr">
                <vue-qrcode :value="oneTimeLoginUrl" :options="qrOptions" tag="img"></vue-qrcode>
              </div>
              <p class="el-oneTime__text limit">QRコードはお客様のスマートフォンですぐに読み取って下さい。</p>
              <p class="el-oneTime__text limit">有効期限: {{ limit }}</p>
            </el-col>
            <el-col :span="12">
              <p class="el-oneTime__explain">
                表示されるQRコードは「ワンタイムQRコード」となります。<br />
                本画面表示のQRコードは表示開始から60分間のみ有効です。<br />
                必ず時間内にログインして頂きますようお願い致します。<br />
                読み取り後、ホーム画面やお気に入り等に保存してください。<br />
                但し、QRコードからログインできない場合や控えの保存が正常に完了しない場合は、<br />
                SMSにてお送りいたします「triplecrownマイページ」のURLよりご確認いただけます。
              </p>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="next">
        <el-button type="primary" icon="el-icon-arrow-right" @click="nextPage"
          >QRコード読み取りを確認し完了へ進む</el-button
        >
      </div>
    </template>
    <template v-if="showPaper">
      <div class="message_area">
        <h3>控え書面の印刷</h3>
        担当者に、こちらのタブレットをお渡しください。
        <el-divider></el-divider>
        <div class="text-center">
          <el-button @click="download"><i class="far fa-file-pdf"></i> 控え書面をダウンロード</el-button>
        </div>
      </div>
      <div class="next">
        <el-button type="primary" icon="el-icon-arrow-right" @click="nextPage">控え書面をお渡しし完了へ進む</el-button>
      </div>
    </template>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import VueQrcode from '@chenfengyuan/vue-qrcode'
export default {
  components: {
    VueQrcode
  },
  data() {
    return {
      next: true,
      check: false,
      qrOptions: {
        errorCorrectionLevel: 'M',
        maskPattern: 0,
        margin: 0,
        scale: 1,
        width: 200,
        color: {
          dark: '#000000FF',
          light: '#FFFFFFFF'
        }
      },
      oneTimeLoginUrl: '',
      limit: ''
    }
  },
  created() {
    if (this.showQr && this.getHasContractId) {
      const loading = this.$loading({
        target: '#el-oneTime',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        text: 'QRコード生成中'
      })
      axios
        .get(`/api/store/contract/onetime-login/${this.getHasContractId}`)
        .then((res) => {
          const {onetime_login_url, limit} = res.data
          this.oneTimeLoginUrl = onetime_login_url ?? ''
          this.limit = limit
        })
        .catch((err) => {})
        .finally(() => {
          loading.close()
        })
    }
  },
  mounted() {
    this.$emit('page', 'form-pdf-issue')
    this.updateHasCancel(false)
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'form-upload') {
      next()
    } else {
      this.$emit('next')
    }
  },
  computed: {
    ...mapGetters({
      getHasContractId: 'status/getHasContractId',
      getUserInputForm: 'userInput/getForm'
    }),
    showQr() {
      const {mode} = this.$route.query
      return mode === 'qr'
    },
    showPaper() {
      const {mode} = this.$route.query
      return mode === 'paper'
    }
  },
  methods: {
    ...mapActions({
      updateHasCancel: 'status/updateHasCancel'
    }),
    nextPage() {
      // this.$emit('transition','form-pdf-issue');
      this.$emit('next')
      // this.$router.push({name:'card-complete'})
    },
    download() {
      if (this.getHasContractId) window.open(`/pdf/store/${this.getHasContractId}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.message_area {
  padding: 15px;
  border: 2px solid #eee;
  text-align: center;
}

.next {
  margin-top: 40px;
  text-align: center;
  .el-button {
    border-radius: 0;
    padding-left: 30px;
    padding-right: 30px;
  }
}
.el-oneTime {
  text-align: left;
  margin-top: 40px;
  margin-bottom: 40px;
  padding-left: 20px;
  padding-right: 20px;
  &__qr {
    text-align: center;
    margin: 1rem;
    img {
      max-width: 100%;
    }
  }
  &__text {
    text-align: center;
    &.limit {
      color: red;
    }
  }
}
</style>
